import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { svgProps } from "./defaults";
import { WaveSvg } from "../Wave.styles";
var scalable4 = {
    start: {
        small: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 375 57",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M0 0h375v52.916c-48 7.144-101.5 4.166-158.5-3.158s-101-9.553-213.285 0A68.175 68.175 0 0 1 0 50.782V0Z"
            })
        })),
        large: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M1440 0H0v53.192C178.5 25.9 283.5 27.773 573 59.507s416.5 70.413 867 4.328V0Z"
            })
        }))
    }
};
export { scalable4 };
